<template>
    <div class="tabs_content" id="tab-2">
        <section>
            <a :data-title="$gettext('Přenačíst data o zařízení')" class="tab_button tab_button_refresh title_tooltip" @click.stop="_reloadDeviceEntity" />

            <div class="left">
              <DetailEntityInfo
                  :entity="entity"
              >
                <p v-if="entity.timestamp_paired">
                  <translate class="translate">Spárováno</translate>: <span class="date" v-html="$_date_formatFull(entity.timestamp_paired)"></span>
                  <span>{{ entity.paired_by }}</span>
                </p>
                <p>
                  <translate class="translate">ID odběratele</translate>: <br/><span class="translate">{{ entity.id_subscriber }}</span>
                </p>
                <p>
                  <translate class="translate">Název odběratele</translate>: <br/><span class="translate">{{ entity.subscriber_name }}</span>
                </p>
                <p>
                  <translate class="translate">Název operátora</translate>: <br/><span class="translate">{{ entity.operator_name }}</span>
                </p>
              </DetailEntityInfo>
            </div>

            <div class="right">
                <div class="field_left">
                    <text-input id="name"
                                :required="true"
                                v-model="entity.name"
                                ref="nameref"
                                :disabled="!isEditable"
                    >
                        <translate class="translate">Název</translate>
                    </text-input>
                    <text-input id="type_name"
                                :required="false"
                                :disabled="true"
                                v-model="entity.type_name"
                                ref="typenameref"
                    >
                        <translate class="translate">Typ zařízení</translate>
                    </text-input>
                  <text-input
                              v-if="$_loggedUser_action_allowed('deviceToken', 'read')"
                              id="device_token"
                              :required="false"
                              :disabled="true"
                              v-model="entity.device_token"
                              ref="devicetokenref"
                  >
                    <translate class="translate">Token zařízení</translate>
                  </text-input>
                    <select-box id="subject_type"
                                v-model="entity.id_profile"
                                :options="deviceProfilesOptions"
                                :disabled="!isEditable"
                    >
                        <translate class="translate">Profil zařízení</translate>
                    </select-box>
                </div>
                <div class="field_right">
                    <text-input id="serial_number"
                                :required="false"
                                :disabled="true"
                                v-model="entity.serial_number"
                                ref="serialnumberref"
                    >
                        <translate class="translate">Sériové číslo</translate>
                    </text-input>
                    <text-input id="model"
                                :required="false"
                                :disabled="true"
                                v-model="entity.model"
                                ref="modelref"
                    >
                        <translate class="translate">Model</translate>
                    </text-input>
                    <p class="field">
                        <checkbox-input
                            id="preprovisioned"
                            v-model="entity.pre_provisioned"
                            ref="preprovisionedref"
                            :disabled="!isEditable"
                        >
                            <translate class="translate">Přednastavený</translate>
                        </checkbox-input>
                    </p>
                    <p class="field">
                        <checkbox-input
                            id="usedhcp"
                            v-model="entity.use_dhcp"
                            ref="usedhcpref"
                            :disabled="!isEditable"
                        >
                            <translate class="translate">Používat DHCP</translate>
                        </checkbox-input>
                    </p>
                </div>
            </div>
        </section>
      <section>
        <div class="left">
          <h2 v-translate>Poslední start</h2>
          <p v-if="entity.last_start">
            <translate class="translate">Čas startu zařízení</translate>: <span class="date" v-html="$_date_formatFull(entity.last_start)"></span>
          </p>
          <p v-else>
            <translate class="translate">Čas startu zařízení</translate>: <span class="date">Nezaznamenáno</span>
          </p>
          <p v-if="entity.last_start">
            <translate class="translate">Typ startu zařízení</translate>: <span class="date">{{ freshStartText}}</span>
          </p>
        </div>
        <div class="right">
          <div class="field_left">
            <text-input id="private_ip"
                        :required="false"
                        :disabled="true"
                        v-model="entity.private_ip"
                        ref="privateipref"
            >
              <translate class="translate">Privátní IP adresa</translate>
            </text-input>
          </div>
          <div class="field_right">
            <text-input id="public_ip"
                        :required="false"
                        :disabled="true"
                        v-model="entity.public_ip"
                        ref="publicipref"
            >
              <translate class="translate">Veřejná IP adresa</translate>
            </text-input>
          </div>
            <div class="field_left">
              <text-input id="application"
                          :required="false"
                          :disabled="true"
                          v-model="entity.application"
                          ref="applicationref"
              >
                <translate class="translate">Aplikace</translate>
              </text-input>
            </div>
            <div class="field_right">
              <text-input id="firmware"
                          :required="false"
                          :disabled="true"
                          v-model="entity.firmware"
                          ref="firmwareref"
              >
                <translate class="translate">Firmware</translate>
              </text-input>
            </div>
        </div>
      </section>
      <section>
        <div class="left">
          <h2 v-translate>Uživatelský profil</h2>
        </div>
        <div class="right">
          <div class="field_left">
            <checkbox-input
                id="remembersubscriberprofile"
                v-model="entity.remember_subscriber_profile"
                ref="remembersubscriberprofileref"
                :disabled="!isEditable"
            >
              <translate class="translate">Automaticky přihlašovat do vybraného uživatelského profilu</translate>
            </checkbox-input>
          </div>
          <div class="field_right">
            <select-box id="idlastsubsriberprofile"
                        v-model="entity.id_last_subscriber_profile"
                        :options="profileOptions"
                        :disabled="!isEditable || !entity.remember_subscriber_profile"
                        :help-text="$gettext('Poslední spuštěný profil na zařízení')"
            >
              <translate class="translate">Vybraný uživatelský profil</translate>
            </select-box>
          </div>
        </div>
      </section>
      <section>
        <div class="left">
          <h2 v-translate>Nastavení v zařízení</h2>
        </div>
        <div class="right">
          <div class="field">
            <JSONTextareaInput
                v-model="entity.device_settings"
                rows="15"
                :disabled="true"
            >
              <translate class="translate">JSON konfigurace</translate>
            </JSONTextareaInput>
          </div>
        </div>
      </section>
    </div>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo";
import JSONTextareaInput from "../../../common/JSONTextareaInput.vue";

export default {
    name: "Dashboard",
    components: {JSONTextareaInput, DetailEntityInfo},
    props: {
        entity: Object,
        isEditable: Boolean,
        availableDeviceProfiles: Array,
    },
  data(){
      return {
        profileOptions: [],
      }
  },
  created(SubscriberProfileService){
      this.subscriberProfileService = SubscriberProfileService;
  },
  mounted() {
    this.subscriberProfileService.getSelectboxList(this.entity.id_subscriber, {id_selected_operator: this.$_loggedUser_selectedOperatorId, default_profile: false})
        .then(data => {
          this.profileOptions = data['subscriber_profiles'];
          this.profileOptions.unshift({id: null, text: this.$gettext('Neuvedeno')});
        });
  },
    methods: {
        _reloadDeviceEntity() {
            this.$emit('reloadEntity');
        }
    },
    computed: {
        deviceProfilesOptions() {
            let options = []
            this._.forEach(this.availableDeviceProfiles, function (deviceProfile) {
                options.push({
                    id: deviceProfile.id,
                    text: deviceProfile.name
                })
            })
            return options
        },
      freshStartText(){
          return this.entity.fresh_start
            ? this.$gettext("Z vypnutého stavu")
            : this.$gettext("Z režimu Standby")
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/Dashboard.vue